import {RteImgLazy} from 'app/modules/editorContent/rteImg/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineRteImg(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-rte-img')) {
        return;
    }

    customElements.define(
        'gem-rte-img',
        class extends WebComponentLoader {
            reactLazyComponent = RteImgLazy;
            hasConfig = false;
        },
    );
}
